import styled from "styled-components";

export const SeoTabsCont = styled.section`
  & .seoTabs h3:after {
    content: "";
    position: absolute;
    display: block;
    width: 100%;
    height: 3px;
    bottom: -2px;
    left: 0;
    background-color: var(--blue);
    transform: scaleX(0);
    transform-origin: top ${({ theme }) => (theme.isRTL ? `right` : `left`)};
    transition: transform 0.3s ease;
  }

  & .seoTabs h3.selected {
    color: #000;
  }

  & .seoTabs h3.selected:after {
    transform: scaleX(1);
  }
`;
